import type { QueryResult, QueryResultData, VisualizationType } from '../types/analytics.types';

export function selectVisualization(result: QueryResult): VisualizationType {
  const { data } = result;

  switch (data.type) {
    case 'count':
      return 'big_number';

    case 'trend':
      return 'line';

    case 'breakdown': {
      const groupCount = data.groups.length;
      if (groupCount <= 5) return 'donut';
      if (groupCount <= 12) return 'horizontal_bar';
      return 'table';
    }

    case 'list':
      return 'table';

    default:
      return 'table';
  }
}

export function getAllowedVisualizations(
  resultType: QueryResultData['type']
): VisualizationType[] {
  switch (resultType) {
    case 'count':
      return ['big_number'];
    case 'trend':
      return ['line', 'vertical_bar'];
    case 'breakdown':
      return ['horizontal_bar', 'vertical_bar', 'donut', 'table'];
    case 'list':
      return ['table'];
    default:
      return ['table'];
  }
}

export const VISUALIZATION_LABELS: Record<VisualizationType, string> = {
  big_number: 'Big Number',
  horizontal_bar: 'Horizontal Bar',
  vertical_bar: 'Vertical Bar',
  line: 'Line Chart',
  donut: 'Donut Chart',
  table: 'Table',
};

export const CHART_COLORS = {
  primary: '#6b7a99',
  secondary: '#7a9e9e',
  tertiary: '#b8a07a',
  quaternary: '#8e8aab',
  quinary: '#a8899a',

  sequential: [
    '#e8ebf0',
    '#c9d0dc',
    '#a5b0c4',
    '#8291ab',
    '#6b7a99',
  ],

  categorical: [
    '#6b7a99',
    '#7a9e9e',
    '#b8a07a',
    '#8e8aab',
    '#a8899a',
    '#7a96a8',
    '#a89078',
    '#8a9e82',
  ],

  success: '#7a9e82',
  warning: '#b8a07a',
  danger: '#b07878',
  neutral: '#9ca3af',
};
